import { DayLogById, State } from '../../types'

export function getLogs(state: State, label: string): DayLogById {
	return state.LogsById[label] || { tempMax: 0, tempMin: 0, logs: [] }
}
